module.exports = __webpack_public_path__ + "static/media/bam.29676d56.png";